export default __webpack_public_path__ + "static/char-sp01-9c8245e5de753ea925b29e91ff1dd04b.webp";